export default class QuoteResultAnalyzer {
    private quoteResult: any;

    private analysis: any = {};

    constructor(_quote: any) {
        this.quoteResult = _quote;
    }

    public analyze() {
        this.analysis.total = this.quoteResult.quote_amount;
        this.analysis.quoteInfo = this.quoteResult.quote_info;
        this.analysis.accList = [];
        this.analysis.base_list = [];
        if (!Array.isArray(this.quoteResult.quote_lines)) {
            this.quoteResult.quote_lines = Object.keys(this.quoteResult.quote_lines).map(
                i => this.quoteResult.quote_lines[i]
            );
        }
        for (let { items, index } of this.quoteResult.quote_lines.map((items: any, index: any) => ({
            items,
            index,
        }))) {
            if (items.lines) {
                items = items.lines;
            }
            if (!Array.isArray(items)) {
                continue;
            }
            for (const item of items) {
                if (
                    item.tms_quote_lines_type == 'CHARGE-BASE' ||
                    item.tms_quote_lines_type == 'CHARGE-MIN' ||
                    item.rate_type == 'CHARGE-BASE' ||
                    item.rate_type == 'CHARGE-MIN'
                ) {
                    // base charge
                    // this.analysis['baseCharge'] = item;
                    this.analysis.base_list.push(item);
                }
                if (item.tms_quote_lines_type == 'CHARGE-ACC' || item.rate_type == 'CHARGE-ACC') {
                    // accessorial charge
                    this.analysis.accList.push(item);
                }
            }
        }
    }

    public mapEstimate(input: any) {
        // map estimate quote amount with result
        let result = this.analysis;
        input.total = result.total || 0;
        // input.palletSpaceCharge = result.baseCharge && (result.baseCharge.tms_quote_lines_quote_amount || result.baseCharge.rate_amount_total);
        // input.palletSpaceChargeText = result.baseCharge && (result.baseCharge.tms_quote_lines_calc_text || result.baseCharge.rate_external_text);
        input.palletSpaceChargeList = [];
        input.quoteInfo = result.quoteInfo;
        input.analysis = [];
        input.complianceCharge = 0;
        for (let i of this.analysis.base_list) {
            let baseData = {
                palletSpaceCharge: i.tms_quote_lines_quote_amount || i.rate_amount_total,
                palletSpaceChargeText: i.tms_quote_lines_calc_text || i.rate_external_text,
            };
            input.palletSpaceChargeList.push(baseData);
        }
        for (let i of this.analysis.accList) {
            if (
                i.tms_quote_lines_calc_text == 'California Compliance Surcharge' ||
                i.rate_external_text == 'California Compliance Surcharge'
            ) {
                input.complianceCharge = i.tms_quote_lines_quote_amount
                    ? i.tms_quote_lines_quote_amount
                    : i.rate_amount_total;
            }
            let accData = {
                name: i.tms_quote_lines_calc_text
                    ? i.tms_quote_lines_calc_text
                    : i.rate_external_text,
                price: i.tms_quote_lines_quote_amount
                    ? i.tms_quote_lines_quote_amount
                    : i.rate_amount_total,
            };
            input.analysis.push(accData);
        }
        console.log(input);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/getQuoteUnis100/quoteResultAnalyzer.ts